
export const globalBackgroundCapitalization = (status: string = ""): string => {
    const s = status.toLowerCase();
    if (s === "issuing") return "#e3f2fd"; // Light Blue
    if (s === "issued") return "#ddffe9"; // Light Green
    if (s === "awaiting_payment") return "#fdf8b1"; // Light Yellow
    if (s === "pending") return "#ffecdb"; // Light Orange
    if (s === "canceled") return "#fcedea"; // Light Red
    if (s === "redemption_requested") return "#e0faff"; // Cyan
    if (s === "redemption_completed") return "#e9f8f5"; // Teal
    return "#EBEDEF"; // Default Grey
};

export const globalColorTextCapitalization = (status: string = ""): string => {
    const s = status.toLowerCase();
    if (s === "issuing") return "#0288d1";
    if (s === "issued") return "#0f8a0d";
    if (s === "awaiting_payment") return "#f57c00";
    if (s === "pending") return "#ed6c02";
    if (s === "canceled") return "#e36b5b";
    if (s === "redemption_requested") return "#0f92d4";
    if (s === "redemption_completed") return "#43b897";
    return "#6c757d";
};
